module.exports = __webpack_public_path__ + "static/aboutfeatfree-32675e355e4be63d16a34c7ed818a73c.png";